// Stale-bundle notice gate (#19521): tabs on releases older than 14 days re-report errors
// already fixed; suppress them. Bundle age comes from the vYY-MM-DD.N release tag.

const DAY_IN_MS = 24 * 60 * 60 * 1000;
const MAX_BUNDLE_AGE_MS = 14 * DAY_IN_MS;
// Release tags encode the release date as vYY-MM-DD.N; anything else fails open
const RELEASE_TAG_PATTERN = /^v(\d{2})-(\d{2})-(\d{2})(\.\d+)?$/;

export const shouldSuppressStaleBundleNotice = (revision) => {
  const match = RELEASE_TAG_PATTERN.exec(revision || '');
  if (!match) {
    return false;
  }

  const [, year, month, day] = match;
  const releasedAtMs = Date.UTC(2000 + Number(year), Number(month) - 1, Number(day));
  return Date.now() - releasedAtMs > MAX_BUNDLE_AGE_MS;
};
